import { FormValueConverter } from "../FormField";
import { StringUtil } from "@eres/core";


class MobileNumberConverter implements FormValueConverter<string> {
	toData( mobile: string ): string | null {
		mobile = FormatMobileDisplay( mobile );
		return mobile;
	}

	toText( mobile: string ): string | null {
		return FormatMobileDisplay( mobile );
	};
}

export function FormatMobileDisplay( mobile: string ): string {
	if ( StringUtil.isEmptyStringOrNull( mobile ) || !( mobile.startsWith( "971" ) || mobile.startsWith( "+971" ) ) ) return "+971";
	mobile = "+" + mobile.replace( /[^0-9]*/g, "" );
	const EidRx = /(\+971)(5[0234568]?)(\d{0,7})/gm;
	let m: RegExpExecArray | null = EidRx.exec( mobile );
	let x: string[] = [];
	let isValid = true;
	if ( m ) {
		m.forEach( ( match ) => {
			x.push( match );
		} );
		if ( x.length > 0 ) {
			x.shift();
			mobile = x.reduce( ( previousValue: string, currentValue: string, ix ) => {
				if ( !StringUtil.isEmptyStringOrNull( currentValue ) ) {
					if ( ix === 0 ) return currentValue;
					if ( isValid )
						previousValue = previousValue + "-" + currentValue;
					if ( ix === 1 && x[ ix + 1 ].length > 0 ) isValid = currentValue.length === 2;
				}
				return previousValue;
			}, "" );
		}

	} else {
		mobile = "+971";
	}
	return mobile;
}

const Converter = new MobileNumberConverter();
export default Converter;
